import React from 'react';

import { JobStatusEnum } from '../components/job/types/job-status-enum';
import {
  GetJobStatusListResult,
  useGetJobStatusList,
} from '../data/useGetJobStatusList';

export const useGetVisibleJobStatuses = (options?: {
  skip: boolean;
}): {
  loading?: boolean;
  error?: boolean;
  data?: GetJobStatusListResult[];
} => {
  const statuses = useGetJobStatusList({ skip: options?.skip });

  return React.useMemo(() => {
    if (statuses.loading) {
      return { loading: true };
    }
    if (statuses.error) {
      return { error: true };
    }

    const data = getVisibleStatusesFromJobStatuses(statuses.data);
    return { data };
  }, [statuses]);
};

export function getVisibleStatusesFromJobStatuses(
  statuses: GetJobStatusListResult[] | undefined
) {
  // ditch the deleted ones and the closed one
  return statuses
    ?.filter(
      (status) =>
        !status.wfDeletedOnUtc &&
        status.status !== JobStatusEnum.valuesEnum.Closed
    )
    .sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));
}
